import styled from 'styled-components';
import { Checkbox } from '@material-ui/core';

export const StyledCheckbox = styled(Checkbox)``;
